import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin } from "lucide-react";
export default function LocationsHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="7631" id="service-areas-overview" ref={ref} className="relative w-full dark py-32 overflow-hidden flex flex-col items-center justify-center !text-[hsl(137,66%,31%)] !bg-[hsl(0,0%,96%)] md:py-48">
      {}
      <div className={cn("absolute top-0 left-1/2 -translate-x-1/2 w-px bg-primary/20 transition-all duration-1000 ease-out delay-300", isVisible ? "h-32 opacity-100" : "h-0 opacity-0")} />

      <div className={cn("container px-6 text-center transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="flex items-center justify-center gap-2 mb-6 text-muted-foreground">
          <MapPin className="w-4 h-4 text-primary" />
          <span className="text-xs font-sans font-medium tracking-[0.2em] uppercase !text-[hsl(210,10%,23%)]">SPLENDORA • KINGWOOD • NEW CANEY • PORTER • CLEVELAND</span>
        </div>

        <h1 className="text-4xl font-bold mb-8 tracking-tighter leading-tight uppercase !font-sans !text-[hsl(137,66%,31%)] md:text-6xl lg:text-7xl">SERVING OUR NEIGHBORS</h1>

        <p className="font-sans text-lg max-w-2xl mx-auto mb-12 font-normal leading-relaxed !text-[hsl(210,9%,31%)] md:text-xl">Veteran-owned garage door expertise providing 24/7 emergency support across Kingwood, TX and surrounding communities.</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          {}
          <Button asChild size="lg" className="bg-primary text-white rounded-md px-4 py-2 font-medium">
            <Link to="/ContactUsPage">Contact Us</Link>
          </Button>
          <Button asChild size="lg" className="bg-primary text-white rounded-md px-4 py-2 font-medium">
            <Link to="https://schaefergaragedoors.com/services/">View All Services</Link>
          </Button>
        </div>
      </div>
    </section>;
}